import renderPostsArchive from './components/Archive/Archive';
import renderBooks from './components/Books/Books';
import renderContributors from './components/Contributors/Contributors';
import renderFeaturedBookModalTrigger from './components/FeaturedBookModalTrigger/FeaturedBookModalTrigger';
import renderFooter from './components/Footer';
import renderNav from './components/Nav/Nav';
import renderNewsletterSignup from './components/NewsletterSignup/NewsletterSignup';
import renderSearchResults from './components/Search/SearchResults';
import addTeamMemberGridManager from './components/TeamMemberGrid/TeamMemberGridManager';
import { init as siteInit } from './site';

const renderSiteFeatures = () => {
  siteInit();
  renderNav();
  renderBooks();
  renderContributors();
  renderFeaturedBookModalTrigger();
  renderFooter();
  renderNewsletterSignup();
  renderSearchResults();
  renderPostsArchive();
  addTeamMemberGridManager();
};

window.addEventListener( 'load', renderSiteFeatures );
